import styled, { keyframes } from "styled-components";
import { colors, font, radius, shadow } from "../../styles/theme/tokens";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const popIn = keyframes`
  from { opacity: 0; transform: translateY(8px) scale(0.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`;

const pulse = keyframes`
  0%, 100% { outline-color: rgba(244, 182, 63, 0.9); }
  50% { outline-color: rgba(244, 182, 63, 0.35); }
`;

// Вище за шторку меню (100) і модалки (1000): під час туру по сторінці не клікають
export const Layer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1100;
  animation: ${fadeIn} 0.2s ease-out;
`;

export const Dim = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(30, 27, 58, 0.55);
`;

// «Дірка» в затемненні навколо підсвіченого елемента
export const Spot = styled.div`
  position: absolute;
  border-radius: ${radius.md};
  box-shadow: 0 0 0 9999px rgba(30, 27, 58, 0.55);
  outline: 3px solid ${colors.amber};
  outline-offset: 2px;
  pointer-events: none;
  transition: top 0.25s ease, left 0.25s ease, width 0.25s ease, height 0.25s ease;
  animation: ${pulse} 1.6s ease-in-out infinite;
`;

export const Card = styled.div`
  position: absolute;
  padding: 20px 20px 16px;
  border-radius: ${radius.lg};
  font-family: ${font.text};
  color: ${colors.ink};
  background: ${colors.surface};
  box-shadow: ${shadow.raised};
  transition: top 0.25s ease, left 0.25s ease;
  animation: ${popIn} 0.25s ease-out;
`;

export const Close = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  color: ${colors.muted};
  background: transparent;
  cursor: pointer;

  &:hover {
    background: ${colors.brandSoft};
  }
`;

export const Counter = styled.span`
  display: inline-block;
  padding: 3px 10px;
  border-radius: ${radius.pill};
  font-size: 12px;
  font-weight: 800;
  color: ${colors.brandDeep};
  background: ${colors.brandSoft};
`;

export const Title = styled.h3`
  margin: 10px 32px 6px 0;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.3;
`;

export const Text = styled.p`
  font-size: 15px;
  line-height: 1.5;
  color: ${colors.muted};
`;

export const Points = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
  padding: 12px 14px 12px 30px;
  border-radius: ${radius.md};
  font-size: 14px;
  line-height: 1.45;
  color: ${colors.ink};
  background: ${colors.amberSoft};

  li::marker {
    color: ${colors.amberDeep};
  }
`;

export const Footnote = styled.p`
  margin-top: 8px;
  font-size: 13px;
  color: ${colors.muted};
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 16px;
`;

export const Skip = styled.button`
  padding: 8px 4px;
  border: none;
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 700;
  color: ${colors.muted};
  background: none;
  cursor: pointer;

  &:hover {
    color: ${colors.ink};
  }
`;

export const Buttons = styled.div`
  display: flex;
  gap: 8px;
`;

export const Next = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  border: none;
  border-radius: ${radius.md};
  font-family: ${font.text};
  font-size: 15px;
  font-weight: 800;
  color: #FFFFFF;
  background: ${colors.brand};
  box-shadow: ${shadow.button(colors.brandDeep)};
  cursor: pointer;

  &:active {
    transform: translateY(2px);
  }
`;

export const Back = styled(Next)`
  padding: 10px 12px;
  color: ${colors.brandDeep};
  background: ${colors.brandSoft};
  box-shadow: none;
`;
